export interface IThreeDSecureProviderAutomatedContractResponse {
  onboardingReady: boolean;
  errorReason?: {
    message?: string;
  };
}
